import React from "react";  
import { connect } from "react-redux";
import styled from "styled-components";
import { BREAKPOINTS, Notifications } from "@onelogin/react-components";
import TopBar from "./TopBar";
import WindowRouter from "./WindowRouter";
import { clearNotification } from "../actions/notificationsActions";

const CenteredContent = styled.div`
  display: table;
  width: 100%;
  height: 100%;
`;

const WrappedContent = styled.div`
  position: relative;
  box-sizing: border-box;
  padding-bottom: 52px;
  display: table-cell;
  vertical-align: middle;
  overflow: auto;

  // Removing media queries since it displayed blank screen in mobile/small sized screens
  // @media only screen and (max-width: ${BREAKPOINTS.PORTAL_MIDDLE}),
  //   only screen and (max-height: ${BREAKPOINTS.PHONE_LARGE}) {
  //   width: 100%;
  //   padding: 0;
  //   background-color: #ffffff;
  //   vertical-align: top;
  //   display: block;
  //   height: 100%;
  // }
`;

const AllContent = styled.div`
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin: 24px auto;
  width: 376px;
  line-height: 1.5;
  border-radius: 4px;
  position: relative;
  background-color: #ffffff;
  box-shadow: 0 4px 32px 0 rgba(45, 46, 46, 0.35),
              0 4px 16px 0 rgba(45, 46, 46, 0.08),
              0 0 4px 0 rgba(45, 46, 46, 0.1);

  @media only screen and (max-width: ${BREAKPOINTS.PORTAL_MIDDLE}),
  only screen and (max-height: ${BREAKPOINTS.PHONE_LARGE}) {
    display: block;
    width: 100%;
    margin: 0;
    padding-bottom: 65px; // To give some room for the Google ReCaptcha widget
    border-radius: 0;
    border-width: 0;
    box-shadow: none;
  }
`;

const Container = styled.div`
  height: 100%;
  overflow-wrap: break-word;

  @media only screen and (max-width: ${BREAKPOINTS.PORTAL_MIDDLE}),
    only screen and (max-height: ${BREAKPOINTS.PHONE_LARGE}) {
    width: 100%;
  }
`;

const NotificationContainer = styled.div`
  position: relative;
  height: fit-content;
  width: 100%;
`;

/** Renders login dialog with topbar that is centered on desktop and full width on narrow sreeen */
export const AppWindow = ({ logoUrl, notifications, clearNotification }) => {
  return (
    <CenteredContent>
      <WrappedContent>
        <AllContent>
          <TopBar logoUrl={logoUrl} />
          <Container>
            <NotificationContainer>
              <Notifications
                clearDisplayedNotification={clearNotification}
                notifications={notifications}
                offsets={{
                  mobile: 52,
                  desktop: 108
                }}
              />
            </NotificationContainer>
            <WindowRouter />
          </Container>
        </AllContent>
      </WrappedContent>
    </CenteredContent>
  );
};

const mapStateToProps = state => ({
  logoUrl: state.branding.data.common.logo_url,
  notifications: state.notifications
});

const mapDispatchToProps = dispatch => ({
  clearNotification: id => dispatch(clearNotification(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppWindow);
